export default {
 proxyCookies: true,
 clientAwareness: false,
 cookieAttributes: {"maxAge":604800,"secure":true},
 clients: {"default":{"httpEndpoint":"https://data.staging2.highlight-games.bet/graphql","authType":"Bearer","authHeader":"Authorization","tokenName":"apollo:default.token","tokenStorage":"cookie"}}
}